import { render, staticRenderFns } from "./seckillRules.vue?vue&type=template&id=fe541758"
import script from "./seckillRules.vue?vue&type=script&lang=js"
export * from "./seckillRules.vue?vue&type=script&lang=js"
import style0 from "./seckillRules.vue?vue&type=style&index=0&id=fe541758&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports